module.exports = __webpack_public_path__ + "img/solace_closed.626369f0.png";